module.exports = __webpack_public_path__ + "img/gg.b18f7629.jpg";